import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { AddToCartButton } from '../../containers/MiniPDP/MiniPdpContent.styled';

interface AddToBagButtonProps {
  addToCartLabel: string;
  addToCartHoverLabel: string;
  addToCartTooltipLabel?: string;
  onAddToCart: () => void;
  isAddToCartLoading?: boolean;
}

const AddToBagButton: React.FC<AddToBagButtonProps> = ({
  onAddToCart,
  isAddToCartLoading,
  addToCartLabel,
  addToCartHoverLabel,
  addToCartTooltipLabel,
}) => {
  const [isHover, setHover] = useState(false);
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  const handleAddToBag = () => {
    onAddToCart?.();
  };
  return (
    <Tooltip title={addToCartTooltipLabel} placement="top" arrow>
      <AddToCartButton
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        disabled={isAddToCartLoading}
        color={isHover || isAddToCartLoading ? 'primary' : 'secondary'}
        size="large"
        variant="contained"
        onClick={handleAddToBag}
      >
        {isHover && addToCartHoverLabel ? addToCartHoverLabel : addToCartLabel}
      </AddToCartButton>
    </Tooltip>
  );
};

export { AddToBagButton };
